import {Chip, Tooltip} from '@mui/material';
import {FC} from 'react';
import {getContractCircleStatus} from '../../helpers';
import {DashboardContractData} from '../../../../../../shared/types/api-v2.types';
import {CIRCLE_STATUSES} from '../../constants/status';

interface Props {
  contract: DashboardContractData;
}

export const ContractStatusChip: FC<Props> = ({contract}) => {
  const isArchived = Boolean(contract?.contract?.archived);

  if (isArchived) {
    return (
      <Tooltip title="Архивный контракт" placement="top">
        <Chip
          size="small"
          variant="filled"
          sx={{width: 20, height: 20, cursor: 'pointer', backgroundColor: '#A8ACB0'}}
        />
      </Tooltip>
    );
  }

  const status = getContractCircleStatus(contract, {
    getStatus: (r) => r.lastStatus,
    getPlannedDate: (r) => r.plannedDate,
  });

  if (status === CIRCLE_STATUSES.EMPTY) return null;

  return (
    <Tooltip title={status.label} placement="top">
      <Chip
        size="small"
        variant="filled"
        sx={{width: 20, height: 20, cursor: 'pointer', backgroundColor: status.color}}
      />
    </Tooltip>
  );
};
